import { TInputField } from "../../../../../../providers/ModernAcquisitionProvider/types";
import { TDateState, TDobState } from "../../../DateOfBirthFieldWithProvider";
import { isValidAge } from "./ageVerification";
import getFormattedDay from "./getFormattedDay";
import getFormattedMonth from "./getFormattedMonth";
import getLastDayOfTheMonth from "./getLastDayOfTheMonth";
import isDayValueValid from "./isDayValueValid";

const getFormattedDateValue = (type: string, currentDateState: TDateState): string => {
    if (type === 'month') {
        return getFormattedMonth(currentDateState.month.value);
    } else if (type === 'day') {
        const lastDayOfMonth = getLastDayOfTheMonth({ month: currentDateState.month.value, year: currentDateState.year.value });
        return getFormattedDay(currentDateState.day.value, lastDayOfMonth);
    } else {
        return currentDateState.year.value
    }
}

export const dateHandleChange = (currentDateState: TDateState, type: string, dobState: TDobState): TInputField => {
    const formattedDateValue = getFormattedDateValue(type, currentDateState);
    currentDateState[type] = { ...currentDateState[type], value: formattedDateValue };
    const progressiveValidationState = getProgressiveValidationState(type, currentDateState, dobState);

    return progressiveValidationState;
}

const getProgressiveValidationState = (type: string, currentDateState: TDateState, dobState: Partial<TDobState>): TInputField => {

    const validationState: TInputField = {
        ...currentDateState[type]
    }

    if (type === 'month') {
        if (currentDateState.month.value.length === 2) {
            if (currentDateState.day.value && currentDateState.year.value) {
                if (isValidAge(currentDateState, dobState.maxAge, dobState.minAge)) {
                    validationState.errorType = 'None';
                    validationState.state = 'neutral';
                } else {
                    validationState.errorType = 'invalidInput';
                    validationState.state = 'error';
                }
            } else {
                validationState.errorType = 'None';
                validationState.state = 'neutral';
            }
        }
    } else if (type === 'day') {
        const lastDayOfMonth = getLastDayOfTheMonth({ month: currentDateState.month.value, year: currentDateState.year.value });
        if (isDayValueValid(currentDateState.day.value, lastDayOfMonth)) {
            if (currentDateState.month.value && currentDateState.year.value) {
                if (isValidAge(currentDateState, dobState.maxAge, dobState.minAge)) {
                    validationState.errorType = 'None';
                    validationState.state = 'neutral';
                } else {
                    validationState.errorType = 'invalidInput';
                    validationState.state = 'error';
                }
            } else {
                validationState.errorType = 'None';
                validationState.state = 'neutral';
            }
        }
    } else if (type === 'year') {
        if (currentDateState.year.value.length === 4) {
            if (isValidAge(currentDateState, dobState.maxAge, dobState.minAge)) {
                validationState.errorType = 'None';
                validationState.state = 'neutral';
            } else {
                validationState.errorType = 'invalidInput';
                validationState.state = 'error';
            }
        } else {
            validationState.errorType = 'None';
            validationState.state = 'neutral';
        }
    }

    return validationState;
}

export const dateHandleBlur = (currentDateState: TDateState, type): TInputField => {
    const validationState: TInputField = {
        ...currentDateState[type],
    }

    if (type === 'month') {
        const formattedValue = currentDateState.month.value.padStart(2, '0');
        if (formattedValue === '00') {
            validationState.value = '';
            validationState.errorType = 'invalidInput';
            validationState.state = 'error';
        } else {
            validationState.value = formattedValue;
            validationState.errorType = 'None';
            validationState.state = 'success';
        }
    } else if (type === 'day') {
        const formattedValue = currentDateState.day.value.padStart(2, '0');
        const lastDayOfMonth = getLastDayOfTheMonth({ month: currentDateState.month.value, year: currentDateState.year.value });
        if (formattedValue == '00') {
            validationState.value = '';
            validationState.errorType = 'invalidInput';
            validationState.state = 'error';
        } else if (parseInt(formattedValue) > lastDayOfMonth) {
            validationState.value = '';
            validationState.errorType = 'invalidInput';
            validationState.state = 'error';
        } else {
            validationState.value = formattedValue;
            validationState.errorType = 'None';
            validationState.state = 'success';
        }
    } else if (type === 'year') {
        if (!currentDateState.year.value) {
            validationState.errorType = 'requiredField';
            validationState.state = 'error';
        } else if (currentDateState.year.value.length !== 4) {
            validationState.value = '';
            validationState.errorType = 'invalidInput';
            validationState.state = 'error';
        } else {
            validationState.errorType = 'None';
            validationState.state = 'neutral';
        } 
    }

    return validationState;
}